import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { PlatformSiteAri } from '@atlassian/ari/platform';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import EditSkillModalQuery from './__generated__/EditSkillModalQuery.graphql';
import type {
	EditSkillModalProps,
	EditSkillModalQueries,
	EditSkillModalRuntimeProps,
} from './EditSkillModal';

export const editSkillEntrypoint: EntryPoint<
	EntryPointComponent<
		EditSkillModalQueries,
		Record<string, never>,
		EditSkillModalRuntimeProps,
		EditSkillModalProps
	>,
	{
		cloudId: string;
		skillAri: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_custom-skills-edit-skill-entrypoint" */ './EditSkillModal'
			),
		{
			moduleId: 'custom-skills-edit-skill-entrypoint-id',
			moduleName: 'custom-skills-edit-skill-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId, skillAri }: { cloudId: string; skillAri: string }) => ({
		queries: {
			editSkillQuery: {
				parameters: EditSkillModalQuery,
				variables: {
					skillAri,
					contextAri: PlatformSiteAri.create({ siteId: cloudId }).toString(),
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
		extraProps: {
			cloudId,
			skillAri,
		},
	}),
});
